import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "notOwnUuid",
    standalone: false
})
export class NotOwnUuidPipe implements PipeTransform {
  transform(items: any[], uuid: string): any[] {
    if (!items) return [];
    if (!uuid) return items;

    return items.filter((it) => {
      return it["uuid"] !== uuid;
    });
  }
}
